import { render } from "./MiniObject.vue?vue&type=template&id=288bd28a&scoped=true"
import script from "./MiniObject.vue?vue&type=script&lang=js"
export * from "./MiniObject.vue?vue&type=script&lang=js"

import "./MiniObject.vue?vue&type=style&index=0&id=288bd28a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-288bd28a"

export default script